import type { RegistroDeCatalogo } from './catalogo.tipos'

export const DURACAO_CATALOGO_FRESCO_MS = 12 * 60 * 60 * 1_000
export const IDADE_MAXIMA_CATALOGO_MS = 7 * 24 * 60 * 60 * 1_000
export const LIMITE_CONTEXTOS_CATALOGO = 3

export type ClassificacaoRegistroCatalogo =
  | 'fresco'
  | 'desatualizado'
  | 'expirado'

export const classificarRegistroCatalogo = (
  registro: Pick<RegistroDeCatalogo<unknown>, 'sincronizadoEm' | 'invalidadoEm'>,
  agora: number,
): ClassificacaoRegistroCatalogo => {
  const idade = Math.max(0, agora - registro.sincronizadoEm)

  if (idade > IDADE_MAXIMA_CATALOGO_MS) return 'expirado'
  if (
    registro.invalidadoEm !== undefined
    || idade >= DURACAO_CATALOGO_FRESCO_MS
  ) return 'desatualizado'
  return 'fresco'
}

export const dataAtualizacaoParaHidratacao = (
  sincronizadoEm: number,
  classificacao: Exclude<ClassificacaoRegistroCatalogo, 'expirado'>,
  agora: number,
): number => classificacao === 'fresco'
  ? sincronizadoEm
  : Math.min(
    sincronizadoEm,
    agora - DURACAO_CATALOGO_FRESCO_MS,
  )
